// axios-interceptor.js

import axios from 'axios';
import { API_CONFIG } from '@/config/api.config';

// 创建 Axios 实例
const axiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS
});

// 请求拦截器：在每个请求发送前执行
axiosInstance.interceptors.request.use(
  config => {
    // 从localStorage中获取JWT令牌
    const jwt = localStorage.getItem("jwt");

    // 将JWT令牌添加到请求头中
    if (jwt) {
      config.headers['jwt'] = `${jwt}`;
    }

    // 开发环境日志
    if (API_CONFIG.DEBUG) {
      console.group(`📤 [${config.method.toUpperCase()}] ${config.url}`);
      console.log('🔗 Base URL:', config.baseURL);
      console.log('📁 Path:', config.url);
      console.log('🔍 Params:', config.params);
      console.log('📦 Data:', config.data);
      console.groupEnd();
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  response => {
    if (API_CONFIG.DEBUG) {
      console.group(`📥 [${response.status}] ${response.config.url}`);
      console.log('✅ Response:', response.data);
      console.groupEnd();
    }
    return response;
  },
  error => {
    if (API_CONFIG.DEBUG) {
      console.error(`❌ Error: ${error.message}`, error.response);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
